import type { DescriptionPanelId, FileContainerId } from 'balus-common';
import type { LinkableTargetKey } from '@view-model/domain/key';
import type { LinkerState } from '@view-model/models/common/components/LinkCreator/LinkerState';
import { StickyNode } from '@view-model/models/sticky/StickyNodeView';
import type { StickyZone } from '@view-model/models/sticky/StickyZoneView';
import type { AnnotationLinkOrigin } from '../domain/AnnotationLinkOrigin';

// ファイルコンテナはゾーンより奥に描かれるためゾーンより優先して判定し、手前に描かれる付箋は優先しない。
// 説明パネルは大きいのでゾーンより優先すると、パネルの上に置いたゾーンへ通常のリンクを引けなくなる
export const findAnnotationLinkTarget = (
  linkerState: LinkerState<LinkableTargetKey>,
  linkableElement: StickyNode | StickyZone | null,
  findFileContainerId: () => FileContainerId | null,
  findDescriptionPanelId: () => DescriptionPanelId | null
): AnnotationLinkOrigin | null => {
  if (!linkerState.isCreating() || !linkerState.source || linkableElement instanceof StickyNode) return null;

  const fileContainerId = findFileContainerId();
  if (fileContainerId) return { kind: 'FileContainer', id: fileContainerId };

  if (linkableElement) return null;

  const descriptionPanelId = findDescriptionPanelId();
  return descriptionPanelId ? { kind: 'DescriptionPanel', id: descriptionPanelId } : null;
};
